export const DEFAULT_SUPPLIER_KEY = 'defaultSupplierKey'
export const DEFAULT_UOM = 'defaultUom'